interface Props {
  src?: string
  link?: string
  alt?: string
}
export function Brand({ src, link, alt }: Props) {
  const brand = src ? <img src={src} alt={alt} /> : alt

  return <>{link ? <a href={link}>{brand}</a> : brand}</>
}
